/**
 * ______                       ___  _____
 * | ___ \                     |_  |/  ___|
 * | |_/ /__ _   __ _   ___      | |\ `--.
 * |  __// _` | / _` | / _ \     | | `--. \
 * | |  | (_| || (_| ||  __/ /\__/ //\__/ /
 * \_|   \__,_| \__, | \___| \____/ \____/
 *               __/ |
 *              |___/
 *
 */

// Encoding: UTF-8
$(document).ready(function() {

	/********************************************/
	/*				Externe Links	 			*/
	/********************************************/
	// FÃ¼r Target_blank HTML-konform
	$("area.external, a[rel=external]").attr("target", "_blank");
	$("a[rel=top]").attr("target", "_top");
	$("a[rel=self]").attr("target", "_self");


	// Moodbar - slick
	/*$(".moodbar-content").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		lazyLoad: 'ondemand',
		arrows: true,
		dots: false,
		mobileFirst: true,
	});*/

	// Init lazy loading of images
	init_images();

	set_matrix_height();

	expand_jury_text();
	expand_julit_text();

	reset_advanced_search_forms();

	show_all_prices_search_result();

	init_navi();

	init_typeahead();

	init_search_page();

	init_countdown();

	check_julit_subscription_form_payment_change();

	if ($('#content .eventdetail').length == 1) {
		checkEventRegistrationLinkHash();
	}

	// slowly scrolling to the top of the page
	$(".show-more").on("click", function(e){

		button_id = $(this).attr('id');
		button_id = button_id.replace("show-more_", "");

		$("#show-more-text_" + button_id).animate({
			height: "toggle"
		},
		{
			duration: 1000
			,complete: function() {
	      		$("#show-more_" + button_id).hide();
	    	}
	    });
		e.preventDefault();
	});

	// change cookie settings (reopen dialog)
	$("#changeCookieSettings").on('click', function(e){
		e.preventDefault;
		whCookies.show_dialog();
	});

	/* mehr anzeigen Newsliste */
	// eventlistener for initial-loaded objects
	$(".more-news .load-more").click(function(){
		news_page	= parseInt($(".news").data('page'));
		news_type	= $(".news").data('type');
		news_ids	= $(".news").data('values');
		news_page++;
		$(".more-news").hide();
		$(".loader").show();
		$.ajax({
			url:		"/ajax/newslist",
			type:		"POST",
			data:		{
				page : news_page
				,type: news_type
				,values: news_ids
			},
			dataType:	"html",
			success:	function(data){
				$(".news").append(data);
				$(".news").data('page',news_page);
				$(".loader").hide();
			},
			error:		function(){
				alert("Ajax Error");
			}
		});
	})
	// Eventlistener for new loaded objects
	$(document).on('click','.more-news .load-more-on',function(){
		news_page	= parseInt($(".news").data('page'));
		news_type	= $(".news").data('type');
		news_ids	= $(".news").data('values');
		news_page++;
		$(".more-news").hide();
		$(".loader").show();
		$.ajax({
			url:		"/ajax/newslist",
			type:		"POST",
			data:		{
				page : news_page
				,type: news_type
				,values: news_ids
			},
			dataType:	"html",
			success:	function(data){
				$(".news").append(data);
				$(".news").data('page',news_page);
				$(".loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	})

	/* mehr anzeigen presslist */
	// eventlistener for initial-loaded objects
	$(".more-press-reports .load-more").click(function(){
		report_page	= parseInt($(".press-reports").data('page'));
		report_page++;
		$(".more-press-reports").hide();
		$(".press-loader .loader").show();
		$.ajax({
			url:		"/ajax/presslist",
			type:		"POST",
			data:		{page : report_page},
			dataType:	"html",
			success:	function(data){
				$(".press-reports").append(data);
				$(".press-reports").data('page',report_page);
				$(".press-loader .loader").hide();
			},
			error:		function(){
				alert("Ajax Error");
			}
		});
	})
	// Eventlistener for new loaded objects
	$(document).on('click','.more-press-reports .load-more-on',function(){
		report_page	= parseInt($(".press-reports").data('page'));
		report_page++;
		$(".more-press-reports").hide();
		$(".press-loader .loader").show();
		$.ajax({
			url:		"/ajax/presslist",
			type:		"POST",
			data:		{page : report_page},
			dataType:	"html",
			success:	function(data){
				$(".press-reports").append(data);
				$(".press-reports").data('page',report_page);
				$(".press-loader .loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	})
});

/*
 * decryptThis
 * E-Mail Adresse entschlüsselt
 */
function decryptThis(s) {
	var n=0;
	var r="";
	for(var i=0;i<s.length;i++) {
		n=s.charCodeAt(i);
		if (n>=8364) {n = 128;}
		r += String.fromCharCode(n-(2));
	}
	return r;
}

/*
 * decrypt_mail
 * href Attribut entschlüsseln
 */
function decrypt_mail(element, email, params) {
	if (!params) var params = '';
	element.href = 'mailto:' + decryptThis(email) + params;
}

/**
 * lazy-loading
 * */
function init_images() {
	// Lazy loading of images using jquery.unveil
	// Exceptions:
	//	- whcaptcha
	// $(":not(.whcaptcha)").unveil(20);
}

/**
 * lazy load after every ajax request
 * */
$(document).ajaxComplete(function(event,request, settings ) {
	init_images();
});

function init_typeahead() {
	init_sticky_typeahead();
	/* default options */
	var top				= 0;
	var right			= 0;
	var width			= 0;
	var page_id			= 1;
	var defaultstring 	= "";
	var selector		= ".akj-search-input.default-input";
	var container		= "#typeahead";
	var id_add			= "";

	// get page_id and defaultstring
	$(selector).wh_typeahead({
		ajaxurl:		"/ajax/schnellsuche"
		,page_id:		page_id
		,top:			top
		,right:			right
		,container:		container
		,defaultstring:	defaultstring
		,id_add:		id_add
		,width:			width
		,sprache:		'de'
	});
}
function init_sticky_typeahead() {
	/* default options */
	var top				= 0;
	var right			= 0;
	var width			= 0;
	var page_id			= 1;
	var defaultstring 	= "";
	var selector		= ".akj-sticky-search-input";
	var container		= "#sticky-typeahead";
	var id_add			= "sticky";

	// get page_id and defaultstring
	$(selector).wh_typeahead({
		ajaxurl:		"/ajax/schnellsuche"
		,page_id:		page_id
		,top:			top
		,right:			right
		,container:		container
		,defaultstring:	defaultstring
		,id_add:		id_add
		,width:			width
		,sprache:		'de'
	});
}

function init_navi() {
	// TO-TOP
	var a = $(".navbar.navbar-default.header").height();
	a += $(".navbar .mega-menu").height();
	$(window).bind("scroll", function() {
		if ($(window).scrollTop() > a) {
			$(".totop").show();
			$("#typeahead").children().hide();
		} else {
			$(".totop").hide();
		}
	});

	// slowly scrolling to the top of the page
	$("#footer .totop").click(function(e){
		$("html, body").animate({
			scrollTop: $(".header").offset().top
		},"slow");
		e.preventDefault();
	});

	// slowly scrolling to the letter selection (link-widget)
	$(".alphabet-char .jumpto-top").click(function(e){
		$("html, body").animate({
			scrollTop: $(".abc-chars").offset().top
		},"slow");
		e.preventDefault();
	});

	// Suche ohne Inhalt
	$("button[name='akj_search_submit']").click(function() {
		var b = $(this).closest("form").find("input").val();
		if (b == undefined) {
			b = $(this).parent().prev().val();
		}
		if (b == "" || b == "Suchen nach ...") {
			alert("Bitte geben Sie einen Suchbegriff ein!");
			return false;
		}
		return true;
	});

	/* Tab-Change for different List-Types - search-result - */
	$('.search-types').on("click", ".search-type", function(e) {
		$('.content-tab').addClass('d-none');
		$(".search-type").removeClass('active');
		$(this).addClass('active');
		var tab_name = $(this).children().attr("class").match(/tab-\S+/)[0].split('-')[1];
		$('#'+tab_name).removeClass("d-none");
	});
}

function isMobile() {
  try{ document.createEvent("TouchEvent"); return true; }
  catch(e){ return false; }
}

function set_matrix_height() {
	setTimeout(function(){
		$(".widget-title-title_matrix .matrix").each(function(){
			height_array	= [];
			$(".cover-container",this).each(function(){
				tmp = $(this).find('img').height();
				height_array.push(tmp);
			})
			max_height		= Math.max.apply(Math,height_array);
			$(this).find(".cover-container").css('min-height', max_height + 'px');
			$(this).parent().parent().animate({opacity: 1},200);
		})
	},550);
}

function expand_jury_text() {
	$(".more-text-jury-button").click(function(event){
		$(this).slideUp(100);
		$(".short-jury-text").slideUp(250);
		$(".cut_dots").hide();
		$(".complete_jury_text").slideDown(250);
	})
}

function expand_julit_text() {
	$(".more-text-button").click(function(event){
		$(this).slideUp(100);
		$(".short-text").slideUp(250);
		$(".cut_dots").hide();
		$(".original-text").slideDown(250);
	})
}

function reset_advanced_search_forms() {
	$(".reset-search-form").click(function(){
		$("#advanced-search input[type='text']").val('');
		$("#advanced-search input[type='checkbox']").prop('checked', false);
		$("#advanced-search select").val(0);
	})
}

function show_all_prices_search_result() {
	$(".more-djlp-prices").click(function(e){
		$(this).hide();
		$(this).next('.hidden-djlp-titles').slideToggle(200);
	});
}

// Suche
function init_search_page() {
	// Title Tab
	// @eventlistener for initial-loaded objects
	$("#title div.show-more").click(function(){
		page		= parseInt($("#title .tab-content-count").data('page'));
		search		= $('.tab-content').data('searchstring');
		searchtype	= $('.tab-content').data('searchtype');
		sum			= $('#title .tab-content-count').data('count');
		page++;
		$("#title .show-more").hide();
		$("#title .loader").show();
		$.ajax({
			url:		"/ajax/suche",
			type:		"POST",
			data:		{
				page: page
				,type: 'title'
				,search: search 
				,sum: sum
				,searchtype: searchtype
			},
			dataType:	"html",
			success:	function(data){
				$("#title .tab-content-items").append(data);
				$("#title .tab-content-count").data('page',page);
				$("#title .loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	})
	// @Eventlistener for new loaded objects
	$(document).on('click','#title div.load-more',function(){
		page		= parseInt($("#title .tab-content-count").data('page'));
		search		= $('.tab-content').data('searchstring');
		searchtype	= $('.tab-content').data('searchtype');
		sum			= $('#title .tab-content-count').data('count');
		page++;
		$("#title .load-more").hide();
		$("#title .loader").show();
		$.ajax({
			url:		"/ajax/suche",
			type:		"POST",
			data:		{
				page: page
				,type: 'title'
				,search: search
				,sum: sum
				,searchtype: searchtype
			},
			dataType:	"html",
			success:	function(data){
				$("#title .tab-content-items").append(data);
				$("#title .tab-content-count").data('page',page);
				$("#title .loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	})

	// Person Tab
	// @eventlistener for initial-loaded objects
	$("#person div.show-more").click(function(){
		page		= parseInt($("#person .tab-content-count").data('page'));
		search		= $('.tab-content').data('searchstring');
		searchtype	= $('.tab-content').data('searchtype');
		console.log(searchtype);
		sum			= $('#person .tab-content-count').data('count');
		page++;
		$("#person .show-more").hide();
		$("#person .loader").show();
		$.ajax({
			url:		"/ajax/suche",
			type:		"POST",
			data:		{
				page: page
				,type: 'person'
				,search: search 
				,sum: sum
				,searchtype: searchtype
			},
			dataType:	"html",
			success:	function(data){
				$("#person .tab-content-items").append(data);
				$("#person .tab-content-count").data('page',page);
				$("#person .loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	})
	// @Eventlistener for new loaded objects
	$(document).on('click','#person div.load-more',function(){
		page		= parseInt($("#person .tab-content-count").data('page'));
		search		= $('.tab-content').data('searchstring');
		searchtype	= $('.tab-content').data('searchtype');
		sum			= $('#person .tab-content-count').data('count');
		page++;
		$("#person .load-more").hide();
		$("#person .loader").show();
		$.ajax({
			url:		"/ajax/suche",
			type:		"POST",
			data:		{
				page: page
				,type: 'person'
				,search: search
				,sum: sum
				,searchtype: searchtype
			},
			dataType:	"html",
			success:	function(data){
				$("#person .tab-content-items").append(data);
				$("#person .tab-content-count").data('page',page);
				$("#person .loader").hide();
			},
			error:		function(){
				alert("Fehler beim Laden");
			}
		});
	});
}

function init_countdown() {
	if ($(".countdown-container").length > 0) {
		const pattern		= '<div class="countdown-item">{days}<br><span class="label">Tage</span></div><div class="countdown-item">{hours}<br><span class="label">Stunden</span></div><div class="countdown-item">{minutes}<br><span class="label">Minuten</span></div><div class="countdown-item">{seconds}<br><span class="label">Sekunden</span></div>';
		var dateEndData	= $(".countdown-container").data('until').split(',');
		if (dateEndData.length == 6) {
			var dateEnd			= new Date(dateEndData[0],dateEndData[1],dateEndData[2],dateEndData[3],dateEndData[4],dateEndData[5]);
			var cDown = new Countdown({
				selector:		'.countdown-container'
				,dateEnd:		dateEnd
				,msgPattern:	pattern
				,msgAfter:		''
				,msgBefore:		''
				,onEnd:			function(){
					$(".countdown-container").parent().append('<div class="countdown-content videodetector col-12"></div>');
					$(".countdown-container, .countdown-text").slideUp(200).promise().done(function(){
						$(".countdown-container, .countdown-text").remove();
					});
					$(".countdown-container").parent().slideDown(200);
					loadCountdownContent($(".countdown-container").data('id'));
				}
			});
		}
	}
}

function loadCountdownContent(widget_id) {
	$.ajax({
		url:	'/ajax/load_countdown_content',
		type:	'POST',
		data:	{
			widget_id: widget_id
		},
		success: function(data) {
			if (data.trim().length == 0) {
				$("#widget_" + widget_id).slideUp(200).promise().done(function() {
					$("#widget_" + widget_id).remove();
				});
			} else {
				$('.widget .countdown-content').append(data);
			}
		},
		error: function(error) {
			console.log(error)
		}
	});
}

function checkEventRegistrationLinkHash() {
	var hash = window.location.hash;
	if (hash.trim() == '#event_form') {
		var error_msg	= $('#content .eventdetail .form-error-msg');
		var success_msg	= $('#content .eventdetail .form-success-msg');
		if (error_msg.length == 1) {
			$("html,body").animate({
				scrollTop:	(error_msg.offset().top - 130)
			}, 'slow');
		} else if (success_msg.length == 1) {
			$("html,body").animate({
				scrollTop:	(success_msg.offset().top - 130)
			}, 'slow');
		}
	}
}

// JuLit subscription form -> change of payment method
function check_julit_subscription_form_payment_change() {
	$("input[name=payment_method]").on('change', function(event) {
		const selected_value = event.target.value;
		if (selected_value == 'sepa') {
			$("form .payment-selection").addClass('with-details')
			$("form .sepa-detail")
				.css({ opacity: 1 })
				.slideDown(250);
		} else {
			$("form .payment-selection").removeClass('with-details')
			$("form .sepa-detail")
				.css({ opacity: 0 })
				.slideUp(250);
		}
	});
}